// Time-box a best-effort async operation so it can never trap a
// caller. Resolves when `promise` settles OR after `ms`, whichever
// comes first, and never rejects. The inner promise's rejection is
// swallowed (callers that care wrap their own try/catch anyway).
//
// Used by the leave-match handlers: saving / abandoning a session is
// best-effort cleanup, but a fetch with no timeout (see serverClient
// and sessionStorage) can hang on a wedged localhost socket. Gating
// `onExit()` behind such an await leaves the user stuck in the match.
// `settleWithin` guarantees the escape hatch always fires.
export function settleWithin(promise, ms) {
  return new Promise((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      resolve();
    };
    const timer = setTimeout(finish, ms);
    Promise.resolve(promise)
      .catch(() => {})
      .finally(() => {
        clearTimeout(timer);
        finish();
      });
  });
}
